// extracted by mini-css-extract-plugin
export var list = "FAQSection-module--list--Hlozo";
export var question = "FAQSection-module--question--kmfzS";
export var wrapper = "FAQSection-module--wrapper--iqJJh";